import { ViewModel,View } from "binder"
import { IExecutablePart, IExecutablePartVisitor } from "../executablePart";
import  { CreateInstanceView } from "./createInstance-view"

export class CreateInstanceViewModel extends ViewModel  implements IExecutablePart{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new CreateInstanceView();
    }
    public getTypeId(): string {
        return "VM-1FE47E5A-E4BB-4B22-B42E-C3615E2A4168"
    }

    public set type(v: string) { this._type = v; } public get type(): string { return this._type;} private _type: string;
    public set variableName(v: string) { this._variableName = v; } public get variableName(): string { return this._variableName;} private _variableName: string;
    
    getTypeName():string{
        return this.type;
    }

    setTypeName(v:string){
        this.type = v;
    }
    accept(visitor: IExecutablePartVisitor, parameter: any) {
        return visitor.VisitCreateInstance(this,parameter);
    }
}
